import { makeStyles } from 'tss-react/mui';
import { SITE_LAYOUT } from 'config/siteLayout';

export default makeStyles()((theme) => ({
  container: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    backgroundRepeat: 'no-repeat',
    color: theme.palette.common.white,
    position: 'relative',
    backgroundColor: 'transparent',
  },
  logoContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    padding: theme.spacing(2),
    lineHeight: 0,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.5),
    },
  },
  errorTitle: {
    color: 'inherit',
  },
  /** Message block + Home button; spacing between groups via Stack `spacing`. */
  content: {
    width: '100%',
    maxWidth: SITE_LAYOUT.contentMaxWidth,
  },
  bodyText: {
    color: 'inherit',
  },
  giphyRef: {
    color: theme.palette.common.white,
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
